module.exports = __webpack_public_path__ + "img/益视说明书_19.3e0a25d7.png";